
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { Task } from "@/types/task";

interface Props {
  task?: Task | null;
  onDelete: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export const TaskDialogActions = ({ task, onDelete, onCancel, isSubmitting }: Props) => (
  <div className="flex justify-between gap-2 pt-4">
    {task && (
      <Button
        type="button"
        variant="destructive"
        onClick={onDelete}
        className="gap-2"
      >
        <Trash2 className="w-4 h-4" />
        حذف
      </Button>
    )}
    <div className="flex gap-2 ml-auto">
      <Button type="button" variant="outline" onClick={onCancel}>
        إلغاء
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "جاري الحفظ..." : (task ? "تحديث" : "إضافة")}
      </Button>
    </div>
  </div>
);
